import rest from "@/plugins/rest";
import bus from "@/plugins/bus";
import metrika from '@/plugins/yandex.metrika'

const user = {
    state: () => {
        return {

            //Пользователь
            user: {},
            //уровень кешбэка
            cashback: false,
            //баланс бонусов
            bonus: 0,
            //кол-во непрочитанных push
            pushUnreadCount: 0
            
        }
    },
    getters: {

        getUser(state) {
            return state.user;
        },

        getCashback(state) {
            return state.cashback;
        },

        getBonus(state) {
            return state.bonus;
        },

        getPushUnreadCount(state) {
            return state.pushUnreadCount;
        },

        getUserDataBatch(state, getters) {

            let requests = {
                basket: {
                    CLASS: "basket",
                    METHOD: "getlist",
                    PARAMS: {
                        FILTER: {
                            "DELAY": "N",
                            "CAN_BUY": "Y"
                        },
                    },
                },
                cashback: {
                    CLASS: "bonus",
                    METHOD: "status",
                },
                favorites: {
                    CLASS: "favorites",
                    METHOD: "getlist"
                },

                retail_basket: {
                    CLASS: "retail",
                    METHOD: "basket.getlist",
                    PARAMS: {
                        PAGING: {
                            SIZE: 200,
                            PAGE: 1
                        },
                    },
                },
            };

            if (getters.isAuthorized) {
                requests.user = {
                    CLASS: "user",
                    METHOD: "get",
                };
                requests.bonus = {
                    CLASS: "bonus",
                    METHOD: "balance",
                };
                requests.push_unread = {
                    CLASS: "push",
                    METHOD: "history.getcount",
                    PARAMS: {
                        FILTER: {
                            READ: false
                        },
                    },
                };
            }

            return requests;
        },
        
    },
    mutations: {

        setCashback: (state, value) => {
            state.cashback = value;
        },
        setUser: (state, value) => {
            state.user = value;
        },
        setBonus: (state, value) => {
            state.bonus = value;
        },
        setPushUnreadCount: (state, value) => {
            state.pushUnreadCount = parseInt(value);
        },
        decreasePushUnreadCount: (state) => {
            if(state.pushUnreadCount > 0) {
                state.pushUnreadCount -= 1
            }
        },
        increasePushUnreadCount: (state) => {
            state.pushUnreadCount += 1
        },
       
    },

    actions: {
        /**
         * Загружает данные пользователя
         */
        loadUserData(context) {

            //запрашиваем данные
            rest
                .batch(context.getters.getUserDataBatch)
                .then((results) => {
                    for (var key in results) {
                        let data = results[key];
                        if (data.SUCCESS) {
                            //корзина
                            if (key == "basket") {
                                //убираем отложенные
                                let items = data.ITEMS.filter(i => i.FIELDS.DELAY != 'Y');
                                context.commit('setBasket', items.map((i) => {
                                    return { id: i.FIELDS.PRODUCT_ID, quantity: parseInt(i.FIELDS.QUANTITY), params: i.PARAMS }
                                }));
                            }
                            //профиль пользователя
                            else if (key == "user") {
                                context.commit('setUser', data);
                                //передаём в Яндекс Метрику параметры пользователя
                                metrika.userParams();
                            }
                            //уровень кешбэка
                            else if (key == "cashback") {
                                context.commit('setCashback', data);
                            }
                            //избранное
                            else if (key == "favorites") {
                                context.commit('setFavorites', data.PRODUCTS.map(p => p.FIELDS.ID));
                            }
                            //Кол-во бонусов
                            else if (key == "bonus") {
                                context.commit('setBonus', data.VALUE);
                            }
                            //корзина розничных магазинов 
                            else if (key == "retail_basket") {
                                context.commit('retail/setBasket', data.ITEMS.map((i) => {
                                    return { id: i.PRODUCT_ID, shopId: i.SHOP_ID, quantity: parseInt(i.QUANTITY) }
                                }));
                            }
                            //кол-во непрочитанных пуш
                            else if (key == "push_unread") {
                                context.commit('setPushUnreadCount', data.COUNT);
                            }
                        } else {
                            //показываем сообщение об ошибке
                            bus.emit('OKRAINA_MESSAGE_E_SHOW', { message: data.ERROR_TEXT });
                            return;
                        }
                    }
                });
        },

        
    }

}

export default user;